module.exports = __webpack_public_path__ + "img/user.39f3e03f.png";